export default function preventDefaultEvent(
	e
) {
	return e.preventDefault();
}
